import { createAction } from 'redux-actions';
export const requestGetActivityLogsAction = createAction('REQUEST/GET_ACTIVITY_LOGS_DATA');
export const resetActivityLogsItemsListAction = createAction('RESET/ACTIVITY_LOGS_ITEMS_LIST');

export const requestGetAuditRelatedEntitiesAction = createAction(
  'REQUEST/GET_AUDIT_RELATED_ENTITIES_DATA',
);
